import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=5b030a20&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./Window.vue?vue&type=style&index=0&id=5b030a20&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Window.vue?vue&type=style&index=1&id=5b030a20&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b030a20",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b030a20')) {
      api.createRecord('5b030a20', component.options)
    } else {
      api.reload('5b030a20', component.options)
    }
    module.hot.accept("./Window.vue?vue&type=template&id=5b030a20&scoped=true", function () {
      api.rerender('5b030a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Window.vue"
export default component.exports